import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlockIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "block_FILL0_wght400_GRAD0_opsz48",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 1,
					input: "SourceAlpha"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 2,
					result: "blur"
				}),
				/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .604 }),
				/* @__PURE__ */ _jsx("feComposite", {
					operator: "in",
					in2: "blur"
				}),
				/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
			]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "block_FILL0_wght400_GRAD0_opsz48-2",
			"data-name": "block_FILL0_wght400_GRAD0_opsz48",
			transform: "translate(6 5)",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "matrix(1, 0, 0, 1, -6, -5)",
				filter: "url(#block_FILL0_wght400_GRAD0_opsz48)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "block_FILL0_wght400_GRAD0_opsz48-3",
					"data-name": "block_FILL0_wght400_GRAD0_opsz48",
					d: "M15.7,21.7a5.843,5.843,0,0,1-2.34-.472,5.991,5.991,0,0,1-3.187-3.188,6.031,6.031,0,0,1,0-4.68,5.991,5.991,0,0,1,3.188-3.187,6.031,6.031,0,0,1,4.68,0,5.991,5.991,0,0,1,3.188,3.188,6.031,6.031,0,0,1,0,4.68,5.991,5.991,0,0,1-3.188,3.188A5.843,5.843,0,0,1,15.7,21.7Zm0-.9a5.07,5.07,0,0,0,5.1-5.1,4.957,4.957,0,0,0-.315-1.755,5.317,5.317,0,0,0-.885-1.53L12.415,19.6a4.808,4.808,0,0,0,1.522.892A5.128,5.128,0,0,0,15.7,20.8Zm-3.885-1.815,7.17-7.17a5.141,5.141,0,0,0-1.53-.9,5.113,5.113,0,0,0-5.37,1.17A4.92,4.92,0,0,0,10.6,15.7a4.816,4.816,0,0,0,.33,1.763A5.549,5.549,0,0,0,11.815,18.985Z",
					transform: "translate(-3.7 -4.7)",
					fill: "#fff"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgBlockIcon);
export default ForwardRef;
